import React from 'react';
import Dialog, { DialogClasses } from '@mui/material/Dialog';
import { styled, SxProps, Breakpoint } from '@mui/system';
import { Grid } from '@mui/material';
import { Theme } from '@emotion/react';

interface ModalProps {
  open: boolean;
  onClose?: () => void;
  children: React.ReactNode;
  fullScreen?: boolean;
  sx?: SxProps<Theme>;
  classes?: Partial<DialogClasses>;
  dialogContainerClass?: string;
  dialogContainerSx?: SxProps<Theme>;
  maxWidth?: Breakpoint;
}

const DialogContainer = styled(Grid)(({ theme }) => ({
  padding: theme.spacing(3),

  background: 'rgba(255, 255, 255, 0.9)',

  backdropFilter: 'blur(14px)',
  WebkitBackdropFilter: 'blur(14px)',

  borderRadius: '20px',

  border: '1px solid rgba(255, 255, 255, 0.18)',

  boxShadow: `
    0 10px 30px rgba(0, 0, 0, 0.18),
    inset 0 1px 0 rgba(255, 255, 255, 0.08)
  `,

  // ✅ Scroll support
  maxHeight: '90vh',
  overflowY: 'auto',
  overflowX: 'hidden',

  // ✅ Hide scrollbar
  scrollbarWidth: 'none', // Firefox
  msOverflowStyle: 'none', // IE + Edge

  '&::-webkit-scrollbar': {
    display: 'none', // Chrome/Safari
  },
}));

function Modal(props: ModalProps) {
  return (
    <Dialog
      maxWidth={props.maxWidth || 'lg'}
      fullScreen={props.fullScreen}
      open={props.open}
      onClose={props.onClose}
      classes={props.classes}
      scroll="paper"
      sx={{
        '& .MuiDialog-paper': {
          borderRadius: '22px',
          background: 'transparent',
          boxShadow: 'none',
        },
        ...props.sx,
      }}
    >
      <DialogContainer sx={props.dialogContainerSx} className={props.dialogContainerClass}>
        {props.children}
      </DialogContainer>
    </Dialog>
  );
}

export default Modal;
